import { Cancel01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import React from "react";
import { useEffect, useMemo, useRef, useState } from "react";
import { Dialog, Slide, IconButton, Paper } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useAppSelector } from "@/hooks";
import { ContentStatus, Offer } from "@/types";
import { IMAGE_PLACEHOLDER } from "@/constants/global";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OffersPopups = () => {
  const [isOpen, setIsOpen] = useState(false);
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const currentOrganization = useAppSelector((store) => store.organizations[organizationId] ?? null);
  const wasRendered = useRef(false);

  const offert = useMemo(() => {
    if (!currentOrganization?.content?.length) return [];

    const content = currentOrganization.content.filter((content: Offer) => {
      if (!("region" in content)) return false;

      if (content?.status === ContentStatus.PUBLISHED && content?.component === "popup") {
        return true;
      }
    });

    return content?.[0];
  }, [currentOrganization?.content]);

  useEffect(() => {
    if (offert && !wasRendered.current) {
      wasRendered.current = true;
      setIsOpen(true);
    }
  }, [offert]);

  if (!offert?.length) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} TransitionComponent={Transition} PaperProps={{ sx: { borderRadius: 6 } }}>
      <IconButton
        size="large"
        elevation={2}
        component={Paper}
        onClick={() => setIsOpen(false)}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
        }}
      >
        <HugeiconsIcon icon={Cancel01Icon} />
      </IconButton>
      <img key={offert.id} width="100%" src={offert?.images?.[0] ?? IMAGE_PLACEHOLDER} alt={offert?.title} />
    </Dialog>
  );
};

export default OffersPopups;
